const menuStructure = [
    { name: 'menuStart', path: 'intro' },
    { name: 'menuProyecto', path: 'proyecto' },
    { name: 'menuEquipo', path: 'equipo' },
    { name: 'menuContacto', path: 'contacto' },
    { name: 'menuPrivacidad', path: 'privacidad' },
];
export default menuStructure;
